// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Comment_Owner__YGmXK {
    font-weight: bold;
    color: #2142b2;
    margin-right: 8px;
  }
  
  .Comment_Date__QVPnD {
    font-weight: lighter;
    color: #c1c1c5;
  }`, "",{"version":3,"sources":["webpack://./src/styles/Comment.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,cAAc;EAChB","sourcesContent":[".Owner {\n    font-weight: bold;\n    color: #2142b2;\n    margin-right: 8px;\n  }\n  \n  .Date {\n    font-weight: lighter;\n    color: #c1c1c5;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Owner": `Comment_Owner__YGmXK`,
	"Date": `Comment_Date__QVPnD`
};
export default ___CSS_LOADER_EXPORT___;
